/** Attachment页面显示的附件类型和必填附件类型管理 */
// 附件类型映射
export const docTypeList = [
  { name: 'spg', value: 'SPG' },
  { name: 'mix_for_new_door', value: 'Floor Plan vs Brand Mix for New Door' },
  { name: 'mix_1st_reno_floor', value: 'Floor Plan vs Brand Mix – 1st Floor' },
  { name: 'mix_for_reno_door_before', value: 'Floor Plan vs Brand Mix for Reno Door - BEFORE' },
  { name: 'mix_for_reno_door_after', value: 'Floor Plan vs Brand Mix for Reno Door - AFTER' },
  { name: 'video', value: 'Video' },
  { name: 'site_condition', value: 'Site Condition' },
  { name: 'confirmation_file', value: 'BP & FIN Confirmation File' },
  { name: 'project_report', value: 'Project Report' },
  { name: 'complete_spg', value: 'Complete SPG' },
  { name: 'fp', value: 'FP' },
  { name: 'cd', value: 'CD' },
  { name: 'facade', value: 'Opening Photo 1 - Facade' },
  { name: 'wide_view', value: 'Opening Photo 2 - Wide View' },
  { name: 'cashier_counter', value: 'Opening Photo 3 - Cashier Counter' },
  { name: 'fitting_room', value: 'Opening Photo 4 - Fitting Room' },
  { name: 'footwear_wall', value: 'Opening Photo 5 - Footwear Wall' },
  { name: 'staircase', value: 'Opening Photo 6 - Staircase' },
  { name: 'others_photo', value: 'Other Photos' }
]

export const openingPictureTypeArr = [
  'facade',
  'wide_view',
  'cashier_counter',
  'fitting_room',
  'footwear_wall',
  'staircase',
  'others_photo'
]

export const openingPictureLabelMap = {
  facade: 'Opening Photo 1 - Facade（请上传2张）',
  wide_view: 'Opening Photo 2 - Wide View（广角图，请上传2张）',
  cashier_counter: 'Opening Photo 3 - Cashier Counter（请上传1张）',
  fitting_room: 'Opening Photo 4 - Fitting Room（请上传1张）',
  footwear_wall: 'Opening Photo 5 - Footwear Wall（请上传2张）',
  staircase: 'Opening Photo 6 - Staircase（如有）',
  others_photo: 'Other Photos（累计开业图总数不少于11张）'
}

// 根据门店类型显示不同附件类型
const KEY_TYPES = [
  'spg',
  'mix_for_new_door',
  'mix_1st_reno_floor',
  'mix_for_reno_door_before',
  'mix_for_reno_door_after',
  'video',
  'site_condition',
  'confirmation_file',
  'project_report',
]
const NON_KEY_TYPES = [
  'spg',
  'mix_for_new_door',
  'mix_1st_reno_floor',
  'mix_for_reno_door_before',
  'mix_for_reno_door_after',
  'video',
  'complete_spg',
  'project_report',
]

// 不能根据format分组，因为有些在n节点的format可能为key而非nonkey
export const attachmentGateConfig: Record<string, string[]> = {
  'K1.1': KEY_TYPES,
  'K1.2': KEY_TYPES,
  'K2.1': KEY_TYPES,
  'K2.2': KEY_TYPES,
  K3: KEY_TYPES,
  'K4.1': KEY_TYPES,
  'K4.2': KEY_TYPES,
  K5: KEY_TYPES,
  K6: KEY_TYPES,
  J7: KEY_TYPES,
  K7: KEY_TYPES,
  K8: KEY_TYPES,
  K9: KEY_TYPES,
  K10: KEY_TYPES,
  'N1.1': NON_KEY_TYPES,
  'N1.2': NON_KEY_TYPES,
  N2: NON_KEY_TYPES,
  N3: NON_KEY_TYPES,
  N4: NON_KEY_TYPES,
  N5: NON_KEY_TYPES,
  N6: NON_KEY_TYPES,
  N7: NON_KEY_TYPES,
  N8: NON_KEY_TYPES,
  J8: NON_KEY_TYPES,
  J9: NON_KEY_TYPES,
  'N9.1': NON_KEY_TYPES,
  'N10.1': NON_KEY_TYPES,
  'N10.2': NON_KEY_TYPES,
  'N10.3': NON_KEY_TYPES,
  'N10.4': NON_KEY_TYPES,
}

// D&C 流程显示的附件类型
export const dcAttachmentGateConfig = ['fp', 'cd']

// 节点必传附件
export const requiredAttachmentConfig: Record<string, string[]> = {
  // Key Door
  'K1.1': ['spg'],
  'K1.2': ['spg'],
  'K2.1': ['spg'],
  'K2.2': ['spg'],
  K3: ['spg', 'site_condition'],
  'K4.1': ['spg', 'site_condition'],
  'K4.2': ['spg', 'site_condition'],
  K5: ['spg', 'site_condition', 'confirmation_file'],
  K6: ['spg', 'site_condition', 'confirmation_file'],
  J7: ['spg', 'site_condition', 'confirmation_file'],
  K7: ['spg', 'site_condition', 'confirmation_file'],
  K8: ['spg', 'site_condition', 'confirmation_file'],
  K9: ['spg', 'site_condition', 'confirmation_file'],
  K10: ['spg', 'site_condition', 'confirmation_file'],

  // Non- Key Door
  'N1.1': ['spg'],
  'N1.2': ['spg'],
  N2: ['spg'],
  N3: ['spg'],
  N4: ['spg'],
  N5: ['spg'],
  N6: ['spg', 'complete_spg'],
  N7: ['spg', 'complete_spg'],
  N8: ['spg', 'complete_spg'],
  J8: ['spg', 'complete_spg'],
  J9: ['spg', 'complete_spg'],
  'N9.1': ['spg', 'complete_spg'],
  'N10.1': ['spg', 'complete_spg'],
  'N10.2': ['spg', 'complete_spg'],
  'N10.3': ['spg', 'complete_spg'],
  'N10.4': ['spg', 'complete_spg'],

  // D&C
  // 'D1': ['fp'],
  // 'D2': ['fp'],
  // 'D3': ['fp', 'cd'],
  // 'D4': ['fp', 'cd'],
  // 'C0': ['fp', 'cd'],
  // 'C1': ['fp', 'cd'],
  // 'C2': ['fp', 'cd'],
  // 'C3': ['fp', 'cd'],
  // 'C4': ['fp', 'cd'],
  D1: ['fp'],
  D2: [],
  D3: ['fp', 'cd'],
  D4: [],
  C0: [],
  C1: [],
  C2: [],
  C3: [],
  C4: [],
}
